import React from 'react';
import { parseZone } from '@common/services/datetime';
import {
  DeprecatedCollapse,
  Gap,
  Gutter,
  Icon,
  Text,
} from '@common/components';
import { toHumanTimeFormat } from 'works/legacy/lib/date-helper';
import type { ShiftConfigType } from './_use-shift-config-check';

export function ShiftConfigsInfo({
  shiftConfigs,
  boundaryHour,
}: {
  shiftConfigs: ShiftConfigType[];
  boundaryHour: number | null;
}) {
  if (shiftConfigs.length === 0) return null;

  return (
    <Gutter size="lg" direction="top">
      <DeprecatedCollapse className="shift-configs-collapse">
        <DeprecatedCollapse.Panel key="shift-configs" header="View Shift Times">
          {shiftConfigs.map((config) => {
            const isDay = isDayShift(config.startTime, boundaryHour);
            const start = toHumanTimeFormat(parseZone(config.startTime));
            const end = toHumanTimeFormat(parseZone(config.endTime));

            return (
              <Gutter key={config.id} size="sm" direction="bottom">
                <Gap size="xs">
                  <Icon
                    icon={isDay ? 'sun' : 'moon'}
                    color={isDay ? 'harvestGold' : 'skyDarker'}
                  />
                  <Text size="lg">
                    {start} - {end}
                  </Text>
                </Gap>
              </Gutter>
            );
          })}
        </DeprecatedCollapse.Panel>
      </DeprecatedCollapse>
      <style jsx>{`
        :global(
          .shift-configs-collapse.wk-collapse
            > .ant-collapse-item
            > .ant-collapse-header
        ) {
          padding-left: 0;
        }
      `}</style>
    </Gutter>
  );
}

function isDayShift(startTime: string, boundaryHour: number | null): boolean {
  if (boundaryHour === null) return false;

  const hour = parseZone(startTime).hour();
  const nightHour = (boundaryHour + 12) % 24;

  if (boundaryHour <= nightHour) {
    return hour >= boundaryHour && hour < nightHour;
  }
  return hour >= boundaryHour || hour < nightHour;
}
